import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Enhanced structured data specifically for Finanzcoaching page
 * Improves search engine understanding and rich snippets
 */
const FinanzcoachingStructuredData: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Finanzcoaching",
    "description": "Professionelles Finanzcoaching für eine gesunde Beziehung zu Geld. Löse finanzielle Blockaden auf und schaffe Klarheit über deine Geldthemen.",
    "provider": {
      "@type": "Person",
      "@id": "https://joerg-hoermann.de/#person",
      "name": "Jörg Hörmann",
      "image": "https://joerg-hoermann.de/images/og-portrait.jpg",
      "telephone": "+49-9171-9892118",
      "email": "info@joerg-hoermann.de",
      "url": "https://joerg-hoermann.de",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Roth",
        "addressRegion": "Bayern",
        "addressCountry": "DE"
      }
    },
    "serviceType": "Finanzcoaching",
    "areaServed": [
      {
        "@type": "State",
        "name": "Bayern"
      },
      {
        "@type": "City", 
        "name": "Nürnberg"
      },
      {
        "@type": "City",
        "name": "München"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Finanzcoaching Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Kostenloses Erstgespräch",
            "description": "Unverbindliches Gespräch zur Klärung Ihrer Bedürfnisse"
          },
          "price": "0",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer", 
          "itemOffered": {
            "@type": "Service",
            "name": "Outdoor-Coaching am Rothsee",
            "description": "Walk & Talk Coaching in der Natur für neue Perspektiven"
          }
        }
      ]
    },
    "offers": {
      "@type": "Offer",
      "name": "Kostenloses Erstgespräch",
      "description": "Unverbindliche Beratung zu Ihren Finanzthemen",
      "price": "0",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "url": "https://zeeg.me/joerghoermann"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default FinanzcoachingStructuredData;